import { render, staticRenderFns } from "./GraphDetail08Template.vue?vue&type=template&id=1f022dc8&scoped=true"
import script from "./GraphDetail08Template.vue?vue&type=script&lang=js"
export * from "./GraphDetail08Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f022dc8",
  null
  
)

export default component.exports